import { PrioritizationCategoryBase } from './base/prioritization-category-base';

export class PrioritizationCategory extends PrioritizationCategoryBase { }